import type { Observable } from 'rxjs';
import type { CrmTag } from '@integrations/crm-tags/contracts/crm-tag.contract';

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CRM_SERVICE_API_BASE } from '@integrations/crm-pipelines';
import { parseResponse } from '@integrations/shared/parse-response';
import { CrmTagCollectionResponseSchema } from '@integrations/crm-tags/contracts/crm-tag.contract';

@Injectable({ providedIn: 'root' })
export class CrmTagsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(CRM_SERVICE_API_BASE);

    public getTags(): Observable<CrmTag[]> {
        return this.http.get<unknown>(`${this.baseUrl}/contact-tags`).pipe(
            map(
                (res) =>
                    parseResponse(res, CrmTagCollectionResponseSchema, {
                        endpoint: 'crm/contact-tags',
                        method: 'GET',
                    }).data
            )
        );
    }
}
